<template>
  <div :class="`as-parent-h2h as-parent-h2h-${siteName}`">
    <div class="as-nav-tabs-btn as-nav-tabs-btn__border">
      <div v-for="index in 3" :key="index">
        <SkeletonLoader width="65px" height="30px" :line="1" />
      </div>
    </div>

    <div class="as-h2h as-scrolling as-scrolling__have-tab as-scrolling__result-popup">
      <div>
        <div class="as-match-list" style="padding-top: 12px;">
          <MatchItemSkeleton v-for="index in 10" :key="index" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import MatchItemSkeleton from "~src/components/skeleton/result-popup/MatchItemSkeleton.vue";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";
const commonStore = usecommonStore();

interface IProps { }

const props = withDefaults(defineProps<IProps>(), {});

const siteName = computed(() => commonStore.getSiteName);

</script>

<script lang="ts">
export default {};
</script>
